import { useCallback, useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router";

const SAVED_PROJECTS_TOOLTIP_EVENT = "saved-projects-tooltip-trigger";

export function useSaveProject() {
  const [searchParams, setSearchParams] = useSearchParams();

  const isSaveProjectVisible = useMemo(
    () => searchParams.get("show-save-project") === "true",
    [searchParams]
  );

  const setIsSaveProjectVisible = useCallback(
    (visible: boolean) => {
      const newParams = new URLSearchParams(searchParams);
      if (visible) {
        newParams.set("show-save-project", "true");
      } else {
        newParams.delete("show-save-project");
      }
      setSearchParams(newParams, { replace: true });
    },
    [searchParams, setSearchParams]
  );

  return {
    isSaveProjectVisible,
    setIsSaveProjectVisible
  };
}

export function triggerSavedProjectsTooltip() {
  window.dispatchEvent(new CustomEvent(SAVED_PROJECTS_TOOLTIP_EVENT));
}

export function useSavedProjectsTooltipListener() {
  const [showTooltip, setShowTooltip] = useState(false);

  const hideTooltip = useCallback(() => {
    setShowTooltip(false);
  }, []);

  useEffect(() => {
    const handleTooltipTrigger = () => {
      setShowTooltip(true);
    };

    window.addEventListener(SAVED_PROJECTS_TOOLTIP_EVENT, handleTooltipTrigger);
    return () => {
      window.removeEventListener(SAVED_PROJECTS_TOOLTIP_EVENT, handleTooltipTrigger);
    };
  }, []);

  return {
    showTooltip,
    hideTooltip
  };
}
